<template>
  <v-card>
    <v-toolbar card color="white">
      <match-filters
        v-model="localFilters"
        :tournament-view="tournamentView"
        @search="search"
      />
      <v-text-field
        v-model="localFilters.match"
        flat
        hide-details
        :placeholder="$t('action.buttons.search')"
        prepend-icon="search"
        solo
      />
      <v-btn small color="primary" @click="setNew">
        {{ $t('action.buttons.new') }}
      </v-btn>
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="formatedList"
        :rows-per-page-items="[10, 25, 50]"
        :loading="loading"
        disable-initial-sort
        :total-items="localPagination.totalItems"
        :pagination.sync="localPagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center px-0">
            <v-icon color="primary" class="mr-1" @click="view(props.item._id)">
              visibility
            </v-icon>
            <v-icon
              v-if="can('edit', 'match')"
              color="success"
              class="mr-1"
              @click="setOne(props.item._id)"
            >
              edit
            </v-icon>
            <v-icon
              v-if="can('delete', 'match') && canDelete(props.item)"
              color="error"
              @click="ifDelete(props.item._id)"
            >
              delete
            </v-icon>
          </td>

          <td class="text-xs-center" style="min-width: 130px">
            {{ props.item.date }}
          </td>
          <td class="text-xs-center">
            {{ props.item.time }}
            <span
              v-if="props.item.wtz && props.item.wtz != $store.state.offset"
              style="font-size: 11px"
              >{{ ` (GMT ${props.item.wtz})` }}</span
            >
          </td>
          <td>
            <v-chip v-if="props.item.homeTeamId" small color="transparent">
              <v-avatar size="32">
                <img :src="props.item.homeTeamLogo" alt />
              </v-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="body-1">
                  {{ props.item.homeTeamId }}
                </v-list-tile-title>
                <v-list-tile-sub-title
                  v-if="props.item.homeTeamCategory"
                  class="caption primary--text text--lighten-1 text-truncate"
                >
                  {{ props.item.homeTeamCategory.join(', ') }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-chip>
            <span v-else>-</span>
          </td>
          <td>
            <v-chip v-if="props.item.visitorTeamId" small color="transparent">
              <v-avatar>
                <img :src="props.item.visitorTeamLogo" />
              </v-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="body-1">
                  {{ props.item.visitorTeamId }}
                </v-list-tile-title>
                <v-list-tile-sub-title
                  v-if="props.item.visitorTeamCategory"
                  class="caption primary--text text--lighten-1 text-truncate"
                >
                  {{ props.item.visitorTeamCategory.join(', ') }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-chip>
            <span v-else>-</span>
          </td>
          <td class="text-xs-center" style="min-width: 350px">
            <template
              v-if="props.item.categories && props.item.categories.length"
            >
              <template v-for="(category, index) in props.item.categories">
                <v-chip :key="index + category" small color="primary" dark>
                  {{ category }}
                </v-chip>
              </template>
            </template>
            <span v-else>-</span>
          </td>
          <td class="text-xs-center">
            {{ props.item.session }}
          </td>
          <td>{{ props.item.type }}</td>
          <td style="min-width: 250px">
            {{ props.item.tournamentId }}
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.active" />
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.started" />
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.ended" />
          </td>
          <td class="text-xs-center">
            {{ props.item.status }}
          </td>
          <!-- <td class="text-xs-center">{{ props.item.wtz || '-' }}</td> -->

          <!-- <td style="min-width:200px">{{ props.item.location }}</td> -->
          <!-- <td class="text-xs-center" style="min-width:180px">
            {{ props.item.createdAt }}
          </td>
          <td style="min-width: 150px">{{ props.item.createdBy }}</td>-->
          <td class="text-xs-center">
            <i
              class="icon material-icons cursor"
              @click="openUpdated(props.item._id)"
              >visibility</i
            >
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-updated-record :dialog.sync="dialogUpdated" :updated="updated" />
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import MatchFilters from './MatchFilters'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'

export default {
  name: 'MatchList',
  components: { DialogDelete, DialogUpdatedRecord, MatchFilters },
  props: {
    tournament: {
      type: Object,
      required: false,
      default: null,
    },
    tournamentView: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      idDelete: '',
      dialogDelete: false,
      dialogUpdated: false,
    }
  },
  watch: {
    dialogUpdated(val) {
      if (!val) this.reset()
    },
    'filters.match': {
      handler: function (/* val, oldVal */) {
        if (this.localPagination.page !== 1) this.localPagination.page = 1
        this.debounceFetch('matches')
      },
    },
    'localPagination.page': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('matches')
      },
    },
    'localPagination.rowsPerPage': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('matches')
      },
    },
    'localPagination.sortBy': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('matches')
      },
    },
    'localPagination.descending': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('matches')
      },
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.matches.loading,
      selected: (state) => state.matches.selected,
      pagination: (state) => state.matches.pagination,
      filters: (state) => state.matches.filters,
    }),
    ...mapGetters({
      formatedList: 'matches/formatedList',
    }),
    headers() {
      return [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },

        {
          text: this.$t('fields.global.date'),
          align: 'center',
          value: 'date',
        },
        {
          text: this.$t('fields.global.time'),
          align: 'center',
          value: 'time',
          sortable: false,
        },

        {
          text: this.$t('fields.matches.homeTeam'),
          value: 'homeTeamId',
          sortable: false,
        },
        {
          text: this.$t('fields.matches.visitorTeam'),
          value: 'visitorTeamId',
          sortable: false,
        },
        {
          text: this.$tc('models.category'),
          align: 'center',
          value: 'categoryId',
          sortable: false,
        },
        {
          text: this.$t('fields.matches.session'),
          align: 'center',
          value: 'session',
        },
        {
          text: this.$t('fields.global.type'),
          value: 'type',
        },
        {
          text: this.$tc('models.tournament'),
          value: 'tournamentId',
          sortable: false,
        },
        {
          text: this.$t('fields.global.state'),
          align: 'center',
          value: 'active',
          sortable: false,
        },
        {
          text: this.$t('titles.matches.started'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.matches.finalized'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('titles.matches.status'),
          align: 'center',
          sortable: false,
        },
        // {
        //   text: 'GMT',
        //   align: 'center',
        //   value: 'wtz'
        // },
        // {
        //   text: this.$t('fields.global.location'),
        //   value: 'location'
        // },

        // {
        //   text: this.$t('fields.global.createdAt'),
        //   align: 'center',
        //   value: 'createdAt'
        // },
        // {
        //   text: this.$t('fields.global.createdBy'),
        //   value: 'createdBy'
        // },
        {
          text: this.$t('titles.global.updates'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('matches/setFilters', value)
      },
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('matches/setPagination', value)
      },
    },
    updated() {
      if (!Array.isArray(this.selected.updated)) return []

      return this.selected.updated
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'matches/fetchOne',
      fetchSimplified: 'matches/fetchSimplified',
      setDelete: 'matches/delete',
      reset: 'matches/reset',
      fetchList: 'matches/fetchList',
    }),
    init() {
      this.debounceFetch('matches')
    },
    search() {
      this.localPagination.page = 1
      this.init()
    },
    setNew() {
      this.reset()
      this.$router.push({ name: 'match-create' })
    },
    view(id) {
      this.$router.push({ name: 'match-view', params: { id } })
      // this.fetchSimplified(id).then(_ => {
      //   this.$nextTick(_ => this.$emit('view'))
      // })
    },
    setOne(id) {
      this.$router.push({ name: 'match-edit', params: { id } })
      // this.fetchOne(id).then(_ => {
      //   this.$nextTick(_ => this.$emit('form'))
      // })
    },
    openUpdated(id) {
      this.fetchOne(id).then(() => (this.dialogUpdated = true))
    },
    canDelete(match) {
      return !(
        (match.started && !match.ended) ||
        (match.streamingStarted && !match.streamingEnded)
      )
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(() => (this.dialogDelete = false))
    },
  },
}
</script>
